<template>
  <div class="userset-bind">
    <div class="title">
      <i class="icon icon-tishi"></i>
      {{ $t('base_userset_bind.bdhkywxdliSynergy') }}
    </div>
    <ul>
      <li>
        <div class="icon-box">
          <i class="icon icon-wechat"></i>
        </div>
        <div class="way">{{ $t('base_userset_bind.wei_xin_deng_lu') }}</div>
        <div class="status">
          <span v-if="isBindWechat">{{ $t('base_userset_bind.yi_bang_ding') }}</span>
        </div>
        <div class="btn" v-if="isBindWechat === true" @click="unbindWechatConfirm">{{ $t('base_userset_bind.jie_bang') }}</div>
        <div class="btn ok" v-if="isBindWechat === false" @click="wxScanLogin(appId, 'bind')">{{ $t('base_userset_bind.bang_ding') }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  data() {
    return {
      appId: '',
      code: '',
      isBindWechat: null
    };
  },
  mounted() {
    this.getLoginConfig();
    this.getBindList();
    //
  },
  methods: {
    // 获取登录配置
    getLoginConfig: function () {
      this.$getJSON(apis.NcConfig).then((res) => {
        this.appId = res.data.appId;
      });
    },
    // 获取绑定平台
    getBindList: function () {
      this.$getJSON(apis.ThirdPartyList).then((res) => {
        this.isBindWechat = !!res.data.find(t => t.provider === 'weixin');
      });
    },
    // 确认解绑弹窗
    unbindWechatConfirm: function () {
      const tips = this.$t('base_userset_bind.nqdyjcwxbdm');
      this.$showConfirm(tips)
        .then(() => {
          this.unbindWechat();
        })
        .catch(() => {});
    },
    // 解除绑定
    unbindWechat: function () {
      const provider = 'weixin';
      this.$postJSON(`${apis.ThirdPartyUnbind}/${provider}`, {}, true)
        .then(() => {
          this.isBindWechat = false;
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success')
          });
        })
        .then(() => {});
    }
  }
};
</script>

<style lang="scss">
.userset-bind {
  padding: 32px;
  .title {
    border-bottom: 1px solid #e1e6eb;
    padding-left: 10px;
    background: rgba(53, 184, 224, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: rgba(108, 117, 125, 1);
    margin-bottom: 16px;
    .icon {
      color: #0d9ae0;
      margin-right: 10px;
    }
  }
  ul li {
    // height: 100px;
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #e1e6eb;
    padding: 20px;
    .icon-box {
      margin-right: 16px;
      .icon {
        font-size: 30px;
        color: #4cbf00;
      }
    }
    .way {
      color: #2c405e;
      font-size: 14px;
      width: 120px;
    }
    .status {
      flex: 1;
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
    }
    .btn {
      line-height: 30px;
      height: 30px;
      width: 136px;
      text-align: center;
      background-color: #4080ff;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      // &.ok {
      //   background-color: #4080ff;
      //   color: #ffffff;
      // }
    }
  }
}
</style>
